import { SerializableValue, Parser, UrlState, ParserMap, Serializer } from './types';

const createTypeParser = <T extends SerializableValue>(defaultValue: T): Parser<T> => {
  const parsers: Record<string, Parser<SerializableValue>> = {
    boolean: (value: string) => value === 'true',
    number: (value: string) => Number(value),
    string: (value: string) => value,
    object: (value: string) => {
      try {
        return JSON.parse(value);
      } catch {
        return value;
      }
    }
  };

  const type = Array.isArray(defaultValue) ? 'object' : typeof defaultValue;
  return parsers[type] as Parser<T>;
};

export const createParsers = <T extends UrlState>(defaultValues: T): ParserMap<T> => {
  const entries = Object.entries(defaultValues).map(([key, defaultValue]) => [key, createTypeParser(defaultValue)]);

  return Object.fromEntries(entries) as ParserMap<T>;
};

export const serialize = <T extends SerializableValue>(value: T): string => {
  const serializers: Record<string, Serializer<SerializableValue>> = {
    object: (val: SerializableValue) => JSON.stringify(val),
    boolean: (val: SerializableValue) => String(val),
    number: (val: SerializableValue) => String(val),
    string: (val: SerializableValue) => String(val)
  };

  const type = Array.isArray(value) ? 'object' : typeof value;
  const serializer = serializers[type];

  if (!serializer) {
    return String(value);
  }

  return serializer(value);
};
